<div class="toasts-container">
  <evc-info-banner *ngFor="let toast of toastService.toasts$ | async; trackBy:trackBy"
                   [type]="toast.type"
                   [@fade]
                   [icon]="iconName(toast)"
                   [closable]="true"
                   (bannerClosed)="onClose(toast)"
  >
    <div banner-content>
      {{toast.message | translate}}
    </div>
  </evc-info-banner>
</div>
